import React from 'react';
import { inputStyles } from '../../styles/styles';
import { TextField } from "@material-ui/core";

export default function BaseTextField(props) {

    const classes = inputStyles();

    return (
        <TextField
            className={classes.textField}
            size="small"
            variant="outlined"
            InputProps={{
              classes: {
                input: classes.textField,
              },
          
            }}

            {...props}
          />
    )
}